<template>
    <v-card>
        <v-card-title>
            Level events filter
        </v-card-title>
        <v-card-text>
            <v-row>
              <v-col cols="1" style="height: 45px;">
                <v-subheader>Levels</v-subheader>
              </v-col>
              <v-col cols="1" style="height: 45px;">
                <v-text-field v-model="levelStart" label="start" hint="" persistent-hint outlined dense/>
              </v-col>
              <v-col cols="1" style="height: 45px;">
                <v-text-field v-model="levelEnd" label="end" hint="" persistent-hint outlined dense/>
              </v-col>
              <v-col cols="2" style="height: 50px;">
<!--                    <v-text-field v-model="appVersion" label="App version" clearable outlined dense/>-->
                <v-combobox v-model="appVersion" :items="$store.getters.versions" label="App version" clearable outlined dense small-chips/>
              </v-col>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-select v-model="game" :items="['Campaign', 'Multiplayer', 'Classic']" label="Game" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" md="2" style="height: 50px;">
                    <v-btn class="mr-4" @click="loadProgress" align="left" :loading="loading">submit</v-btn>
                </v-col>
            </v-row>
            <br><hr>
            <v-row>
                <v-col md="12">
                    <v-data-table
                            dense
                            :headers="headers"
                            :items="levelProgressEvents"
                            :items-per-page="20"
                            :footer-props="{'items-per-page-options': [10, 20, 50, 100, -1]}"
                            :search="search"
                            style="white-space: nowrap"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Users</v-toolbar-title>
                                <v-divider class="mx-2" inset vertical/>
                                <!--                    <v-btn @click="createItem" class="ma-2" color="primary">-->
                                <!--                        New User-->
                                <!--                    </v-btn>-->
                                <v-spacer/>
                                <v-text-field
                                        append-icon="search"
                                        hide-details
                                        label="Search"
                                        single-line
                                        v-model.trim="search"
                                />
                            </v-toolbar>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
        <!--        <v-product-dialog ref="product-dialog"/>-->
    </v-card>
</template>

<script>
    import database from "../store/database";
    import dayJS from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import * as firebase from 'firebase/app'
    import store from "@/store";

    dayJS.extend(relativeTime);

    export default {
        name: "LevelProgressEvents",
        //components: {VProductDialog},
        data: (vm) => ({
            search: "",
            headers: [
                { text: "Level", value: "level"},
                { text: "Start", value: "start"},
                { text: "Complete", value: "complete"},
                { text: "Fail", value: "fail"},
                { text: "Quit", value: "quit"},
                { text: "Count", value: "count"},
            ],
          
            appVersion: store.getters.versions[0],
            game:'Campaign',
            levelStart:'1',
            levelEnd:'130',
            levels: []
        }),
        computed: {
          loading() {
            return this.$store.state.loading;
          },
          levelProgressEvents() {
            return store.getters["users/getLevelProgressEvent"]
          },
        },
        watch: {
        },
        methods: {
          loadProgress() {
            store.dispatch("users/loadLevelProgressEvents", {
              start: parseInt(this.levelStart),
              end: parseInt(this.levelEnd),
              game: this.game.toLowerCase(),
              version: this.appVersion
            });
          },
        }
    };
</script>